/**
 * What rejecting a company request does, in one place, because two screens ask it.
 *
 * The request detail page and the requests list both offer Reject. Rejecting is a plain status
 * update (`updateCompanyRequest`), which records the decision and grants nothing, and neither
 * screen offers a way back afterwards: both act only while a request is pending. That last part is
 * what makes a confirmation worth the extra click.
 */
export const REJECT_TITLE = 'Reject this company request?';

export const rejectBody = (employer?: string, company?: string): string =>
  `${employer || 'This employer'} will not be attached to ${company || 'this company'}. ` +
  'The company, its jobs and the employer account stay as they are, and the request is kept, ' +
  'marked rejected. It cannot be approved from the console afterwards.';

/** A request still waiting on a decision. Case-insensitive, as the list's status filter is. */
export const isPendingRequest = (status?: string | null): boolean =>
  (status ?? '').trim().toLowerCase() === 'pending';
